import { render, staticRenderFns } from "./proposal-27-new-hire-guarantee.vue?vue&type=template&id=7a7b62f1"
import script from "./proposal-27-new-hire-guarantee.vue?vue&type=script&lang=js"
export * from "./proposal-27-new-hire-guarantee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports